import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import { objectUtils } from '@codametrix/ui-common';
import { Grid, Text } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { RelationshipEditType } from '../../core/enums';
import { isNumber } from '../../core/type-guards';
import { styles } from './organization.styles';
import './service-line.scss';
import { Checkbox, CheckboxSize } from '../../components/checkbox/checkbox';
const getInitialCheckboxValues = (serviceLines)=>{
    const values = {};
    serviceLines.forEach((sl)=>{
        values[`${sl.id}`] = false;
    });
    return values;
};
const orgRelationshipsToCheckListValues = (orgRelationships, serviceLines)=>{
    const values = {};
    serviceLines.forEach((sl)=>{
        values[`${sl.id}`] = false;
    });
    orgRelationships.forEach((relationship)=>{
        values[`${relationship.serviceLineId}`] = true;
    });
    return values;
};
const ServiceLines = (props)=>{
    const classes = styles();
    const { onChange, orgRelationships, serviceLines } = props;
    const initialCheckboxValues = getInitialCheckboxValues(serviceLines);
    const [checkboxValues, setCheckboxValues] = useState(initialCheckboxValues);
    useEffect(()=>{
        const checkboxValuesMap = orgRelationshipsToCheckListValues(orgRelationships, serviceLines);
        setCheckboxValues(checkboxValuesMap);
    }, [
        orgRelationships,
        serviceLines
    ]);
    const handleServiceLineSelection = (event)=>{
        // 1. update checkboxvalues state with new value
        const values = {
            ...checkboxValues
        };
        values[event.target.id] = event.target.checked;
        setCheckboxValues(values);
        // 2. turn the boolean map into an array so we can work with it as a set.
        const serviceIds = Object.entries(values).filter(([, value])=>{
            return value;
        }).map(([key])=>{
            return key >> 0;
        }).flat();
        const serviceIdsSet = new Set(serviceIds);
        // 3. create the already provided set for symmetry with serviceIds
        const alreadyProvided = objectUtils.uniq(orgRelationships.map((rel)=>{
            return rel.serviceLineId;
        }).flat().filter(isNumber));
        const alreadyProvidedSet = new Set(alreadyProvided);
        // 4. Create a set of edits.  Also include non-updates for clarity.
        const toRemove = alreadyProvided.filter((provided)=>!serviceIdsSet.has(provided) && alreadyProvidedSet.has(provided));
        const noUpdates = serviceIds.filter((serviceId)=>alreadyProvidedSet.has(serviceId));
        const toAdd = serviceIds.filter((serviceId)=>!alreadyProvidedSet.has(serviceId));
        // 5. Assemble our PartialRelationshipEdits
        const edits = [];
        toRemove.forEach((edit)=>{
            edits.push({
                type: RelationshipEditType.REMOVE,
                organizationRelationship: {
                    serviceLineId: edit
                }
            });
        });
        toAdd.forEach((edit)=>{
            edits.push({
                type: RelationshipEditType.ADD,
                organizationRelationship: {
                    serviceLineId: edit
                }
            });
        });
        noUpdates.forEach((edit)=>{
            edits.push({
                type: RelationshipEditType.NOOP,
                organizationRelationship: {
                    serviceLineId: edit
                }
            });
        });
        onChange(edits);
    };
    return /*#__PURE__*/ _jsxs(Grid, {
        sx: classes.input,
        rowGap: 3,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                sx: classes.subtitle,
                children: "Apply to:"
            }),
            /*#__PURE__*/ _jsx(Grid, {
                children: serviceLines.map((serviceLine)=>/*#__PURE__*/ _jsx(Checkbox, {
                        label: serviceLine.name,
                        onChange: handleServiceLineSelection,
                        id: serviceLine.id.toString(),
                        isChecked: checkboxValues[`${serviceLine.id}`],
                        size: CheckboxSize.MD,
                        dataTestId: serviceLine.id.toString()
                    }, serviceLine.id))
            })
        ]
    });
};
ServiceLines.displayName = 'ServiceLines';
export { ServiceLines };
